import React, { useState } from "react"
import { Box } from "@infotech/uikit-grid"
import Spin from "@infotech/uikit-spin"
import { LoaderIcon } from "@infotech/uikit-icons"
import { usePlanByUuid } from "./hook"
import styles from "./styles.css"

const PlanUUID = ({
  match: {
    params: { uuid },
  },
  history,
}) => {
  const [error, setError] = useState(false)
  const pushHistory = history.push
  usePlanByUuid(uuid, pushHistory, setError)
  return (
    <Box loose flex className={styles.LoaderWrapper}>
      {!error ? (
        <Spin duration="fast">
          <LoaderIcon size="big" color="#2880ff" />
        </Spin>
      ) : (
        <Box loose className={styles.TextWrapper}>
          По заданному uuid план не найден.
          <Box loose className={styles.Link} onClick={() => pushHistory(`/`)}>
            Перейти в календарь.
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default PlanUUID
